import type { Logger } from '@feature-hub/core';
import type { CarlineStructureCarline } from '../../web/generated/onegraph';
import CarlineQuery from './carline-query.graphql';
import type { GfaLocaleService, OneGraphService } from '../feature-service-types';

export const createAsyncCarlineFetch = async (
  oneGraphServiceV1: OneGraphService,
  { countryCode: country, language }: GfaLocaleService,
  carlineId: string,
  logger: Logger,
): Promise<CarlineStructureCarline | null> => {
  try {
    const oneGraphClient = oneGraphServiceV1.getApolloClient();

    const {
      data: { carline },
    } = await oneGraphClient.query({
      query: CarlineQuery,
      context: {
        consumerId: `${__FEATURE_APP_NAME__}@${__FEATURE_APP_VERSION__}`,
      },
      variables: {
        identifier: {
          country,
          language,
          id: carlineId,
        },
      },
    });
    return carline;
  } catch (error) {
    logger.info('Error fetching carline:', error);
    return null;
  }
};
